const SIZE_UNITS = 'KMGTPEZY'

/** Formats a byte count to a short human-readable string (e.g. "1.23KB"). Ported from audio-web. */
export const formatSize = (sizeInBytes: number): string => {
    const sign = Math.sign(sizeInBytes)
    let size = Math.abs(sizeInBytes)
    let level = -1

    while (size >= 1000) {
        size /= 1000
        level += 1
    }

    const result = Math.round(size * 100) / 100
    const unit = level === -1 ? '' : SIZE_UNITS[level]

    return `${sign * result}${unit}B`
}
